import { Navigate, Route, Routes } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { RouteLocations } from './RouteLocations';
import {
  UserProvider,
  CreateExperiment,
  EdaConfig,
  ExperimentDesign,
  ExperimentSummary,
  MarketInsights,
  MatchedMarkets,
  PowerAnalysis,
  Help,
} from '@mightyhive/gridmodule';


export function Grid(): JSX.Element {
  const { email, selectedClientExternalUuid } = useUser();

  return (
    <UserProvider initialEmail={email}>
      <Routes>
        <Route index element={<Navigate to="create-experiment" replace />} />
        <Route path="command-center" element={<Navigate to="create-experiment" replace />} />
        <Route path="command-center/:id" element={<Navigate to="../eda-config/:id" replace />} />
        <Route path="create-experiment" element={<CreateExperiment selectedClientExternalUuid={selectedClientExternalUuid} />} />
        <Route path="eda-config" element={<Navigate to="../create-experiment" replace />} />
        <Route path="eda-config/:id" element={<EdaConfig />} />
        <Route path="experiment-design" element={<Navigate to="../create-experiment" replace />} />
        <Route path="experiment-design/:id" element={<ExperimentDesign />} />
        <Route path="market-insights" element={<MarketInsights />} />
        <Route path="market-insights/:id" element={<MarketInsights />} />
        <Route path="matched-markets" element={<MatchedMarkets />} />
        <Route path="matched-markets/:id" element={<MatchedMarkets />} />
        <Route path="power-analysis" element={<PowerAnalysis />} />
        <Route path="power-analysis/:id" element={<PowerAnalysis />} />
        <Route path="experiment-summary" element={<ExperimentSummary />} />
        <Route path="experiment-summary/:id" element={<ExperimentSummary />} />
        <Route path="results-library" element={<Navigate to={RouteLocations.LIBRARY} replace />} />
        <Route path="help" element={<Help />} />
      </Routes>
    </UserProvider>
  );
}